import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import "./Images.css";
export const Images = (props) => {
  const { src, alt, width } = props;
  const [modalShow, setModalShow] = useState(false);

  return (
    <Container>
      <Row>
        <Col xs={6} md={4}>
          <div
            variant="primary"
            className="img-tag editable-pointer-events"
            onClick={() => setModalShow(true)}
          >
            <Image src={src} alt={alt} width={width} rounded />
          </div>
        </Col>
      </Row>

      <MyVerticallyCenteredModal
        show={modalShow}
        src={src}
        alt={alt}
        width={width}
        onHide={() => setModalShow(false)}
      />
    </Container>
  );
};

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-modal"
    >
      {/* <Modal.Footer className="custom-footer">
        <Button variant="outline-light" className="custom-button" onClick={props.onHide}>X</Button>
      </Modal.Footer> */}
      <Modal.Body className="custom-modal-body">
        <Image src={props.src} alt={props.alt} width={"100%"}  rounded />
      </Modal.Body>
    </Modal>
  );
}
